import { render, staticRenderFns } from "./DisplayBoard.vue?vue&type=template&id=3bc5fd77&scoped=true"
import script from "./DisplayBoard.vue?vue&type=script&lang=js"
export * from "./DisplayBoard.vue?vue&type=script&lang=js"
import style0 from "./DisplayBoard.vue?vue&type=style&index=0&id=3bc5fd77&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc5fd77",
  null
  
)

export default component.exports